import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

const QRPayments = () => {
    const [viewable, setViewable] = useState(false);

    const dispatch = useDispatch();
    const formik = useFormik({
        // validationSchema: validationSchema,
        initialValues: {
            id: '',
            customerName: '',
            phoneNumber: '',
            consumerId: '',
            dateOfBirth: '',
            cnic: '',
            gender: '',
            emailAddress: '',
            address: '',
            profileImageBase64: '',
            profileImagePath: '',
            createdBy: ''
        }
    });

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const previousDate = currentDate.toISOString().split('T')[0];
    return (
        <div className="p-4">
            {' '}
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>QR Payments</h3>
            </div>
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid grid mb-5">
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">Start Date</label>
                                <InputText id="dateTo" type="date" name="dateTo" max={previousDate} value={formik?.values?.dateTo || ''} onChange={formik.handleChange} />

                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">End Date</label>
                                <InputText id="dateTo" type="date" name="dateTo" max={previousDate} value={formik?.values?.dateTo || ''} onChange={formik.handleChange} />

                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">STAN</label>
                                <InputText id="roleName" name="roleName" placeholder="Enter Transaction ID" value={formik?.values?.roleName} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>{' '}
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">Transaction ID</label>
                                <InputText id="roleName" name="roleName" placeholder="Enter Transaction ID" value={formik?.values?.roleName} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>{' '}
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">QR Reference ID</label>
                                <InputText id="roleName" name="roleName" placeholder="Enter Transaction ID" value={formik?.values?.roleName} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>{' '}
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="gender">Status</label>
                                <Dropdown id="gender" name="gender" value={formik?.values?.gender} options={[]} optionLabel="name" optionValue="id" onChange={formik.handleChange} placeholder="Select Status" className="w-full" />
                                {formik.touched.gender && formik.errors.gender && <small className="p-error">{formik.errors.gender}</small>}
                            </div>
                        </div>{' '}
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="gender">Bank Name</label>
                                <Dropdown id="gender" name="gender" value={formik?.values?.gender} options={[]} optionLabel="name" optionValue="id" onChange={formik.handleChange} placeholder="Select Status" className="w-full" />
                                {formik.touched.gender && formik.errors.gender && <small className="p-error">{formik.errors.gender}</small>}
                            </div>
                        </div>{' '}
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="gender">QR Type</label>
                                <Dropdown id="gender" name="gender" value={formik?.values?.gender} options={[]} optionLabel="name" optionValue="id" onChange={formik.handleChange} placeholder="Select Status" className="w-full" />
                                {formik.touched.gender && formik.errors.gender && <small className="p-error">{formik.errors.gender}</small>}
                            </div>
                        </div>{' '}
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">QR Title</label>
                                <InputText id="roleName" name="roleName" placeholder="Enter STAN" value={formik?.values?.roleName} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>{' '}
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">Consumer No.</label>
                                <InputText id="roleName" name="roleName" placeholder="Enter STAN" value={formik?.values?.roleName} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>{' '}
                        <div className="live__SearchBtn p-field col-12 md:col-12">
                            {/* <Button disabled={loading} loadingIcon={loadingIcon} icon={loadingIcon} iconPos="left" label="Search" className="Btn__Dark__Search" /> */}
                            <Button label="Search" icon="pi pi-search" className="Btn__Dark__Search" />

                            <Button
                                label="Reset"
                                // onClick={(e) => resetHandle(e)}
                                className="Btn__Transparent__Reset"
                            />
                        </div>
                    </div>
                </form>
            </div>
            {/* <div className="Form__Header mt-5">
                <h1>Live Transactions</h1>
            </div> */}
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <DataTable
                            paginator
                            rows={15}
                            rowsPerPageOptions={[5, 10, 20]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                            emptyMessage="No List found."
                            responsiveLayout="scroll"
                            value={[]}
                            className="p-datatable-sm datatable-responsive"
                        >
                            <Column field="" header="Date Time" />
                            <Column field="roleCode" header="Reference ID" />
                            <Column field="" header="QR Title" />
                            <Column field="" header="Type" />
                            <Column field="" header="Customer Name" />
                            <Column field="" header="Customer Account" />
                            <Column field="roleCode" header="Amount" />
                            <Column field="roleCode" header="Bank" />
                            <Column field="email" header="Status" />
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QRPayments;
